import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cx-reset-form"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { id: "reset-form" }
const _hoisted_5 = { for: "id_password1" }
const _hoisted_6 = {
  key: 0,
  class: "errorlist"
}
const _hoisted_7 = { for: "id_password2" }
const _hoisted_8 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cx_spinner = _resolveComponent("cx-spinner")

  return (_ctx.username)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.translations.hi), 1 /* TEXT */),
          _createVNode("strong", null, " " + _toDisplayString(_ctx.username), 1),
          _hoisted_2,
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.translations.choose), 1 /* TEXT */)
        ]),
        _createVNode("form", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.translations.password1), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.password1 = $event)),
            required: "",
            id: "id_password1"
          }, null, 512), [
            [_vModelText, _ctx.password1]
          ]),
          (_ctx.resetError)
            ? (_openBlock(), _createBlock("ul", _hoisted_6, [
                _createVNode("li", null, _toDisplayString(_ctx.resetErrorText), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.translations.password2), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.password2 = $event)),
            required: "",
            id: "id_password2"
          }, null, 512), [
            [_vModelText, _ctx.password2]
          ]),
          _createVNode("button", {
            class: "btn btn-default btn-block m-t-20",
            onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.resetPassword(...args)))
          }, [
            (!_ctx.isResetQueryInProgress)
              ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.translations.set), 1))
              : _createCommentVNode("", true),
            (_ctx.isResetQueryInProgress)
              ? (_openBlock(), _createBlock(_component_cx_spinner, {
                  key: 1,
                  loading: true,
                  size: 20,
                  color1: "white",
                  stroke1: 3,
                  stroke2: 0.5
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}